import { render } from "./DropBoxLocation.vue?vue&type=template&id=7e0dcffe&scoped=true"
import script from "./DropBoxLocation.vue?vue&type=script&lang=js"
export * from "./DropBoxLocation.vue?vue&type=script&lang=js"

import "./DropBoxLocation.vue?vue&type=style&index=0&id=7e0dcffe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0dcffe"]])

export default __exports__